<template>
    <div style="padding-top: 60px;">
        <iframe :src="src" frameborder="0" style="width: 100%;height: 80vh"></iframe>
    </div>
</template>
<script>
import {
    OpenQQLoginUrl, OpenWXLoginUrl
} from 'Services/getData.js';
export default {
    data (){
        return {
            src: '',
            params: {
                app_id: '',
                redirect_url: ''
            }
        }
    },
    methods: {
        async getLogin(type){
            let res;
            if(type === 'qq'){
                res = await OpenQQLoginUrl(this.params);
            }else{
                res = await OpenWXLoginUrl(this.params);
            }
            if(res.data.code === 0){
                this.src = res.data.data.url;
            }
        }
    },
    mounted(){
        this.params.app_id = this.$route.query.app_id;
        this.params.redirect_url = location.href.split('?')[1].split('&redirect_url=')[1];
        this.getLogin(this.$route.query.type);
    }
}
</script>